import React, {Component} from 'react';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Checkbox from 'material-ui/Checkbox';

export default class BranchSearchToolbar extends Component {
    constructor(props){
        super(props);
        this.state = {key: '', value: 6, checked: false}
    }

    setSearchKey(key){
        this.setState({key: key})
    }

    handleOnSearchClicked(){
        this.props.onSearchClicked(this.state.key, this.state.value, this.state.checked);
    };

    handleChange = (event, index, value) => this.setState({value});

    handleChecked = (event, index, value) => {
        this.setState((oldState) => {
            return {
                checked: !oldState.checked,
            };
        });
    }

    render() {
        return (
            <div>
                <Grid fluid>
                    <Row>
                        <Col xs={6} sm={6} md={6} lg={6}>
                            <div>
                                <SelectField
                                    floatingLabelText="Access group"
                                    value={this.state.value}
                                    onChange={this.handleChange}>
                                    {this.props.groups?this.props.groups.map(group => <MenuItem key={group.id} value={group.id} primaryText={group.name} />):[]}
                                </SelectField>
                            </div>
                        </Col>
                        <Col xs={6} sm={6} md={6} lg={6}>
                            <div>
                                <TextField onChange={(e, value)=>{this.setSearchKey(value)}}
                                           hintText="Country, customer or branch.." />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={6} sm={6} md={6} lg={6}>
                            <div>
                                <Checkbox label="Include countries in search" onCheck={this.handleChecked}/>
                            </div>
                        </Col>
                        <Col xs={6} sm={6} md={6} lg={6}>
                            <div style={{align: 'middle'}}>
                                <RaisedButton label="Find" primary={true}
                                              onTouchTap={()=>{this.handleOnSearchClicked()}}/>
                            </div>
                        </Col>
                    </Row>

                </Grid>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/branchSelector/SearchToolbar.js